import { ModulePrefixes } from "enums";
import LeftMenuCard from "./LeftMenuCard";
import { useLocation } from "react-router-dom";
import { siteTempleteUsersMenu } from "staticData";
import { t } from "i18next";
import { useUserPermissions } from "hooks/user";
import { useSearch } from "helpers";

export default function SiteTempleteUsersMenu() {
  const { search } = useLocation();
  const { app_users_view_users } = useUserPermissions();
  const { web = null } = useSearch();

  return (
    <>
      <div className="card-div">
        {siteTempleteUsersMenu(app_users_view_users).map((item, index) => (
          <LeftMenuCard
            key={`${index}-${item.module}`}
            {...item}
            title={t(item.title)}
            prefix={web ? ModulePrefixes.SITE_SETTINGS: ModulePrefixes.SITE_TEMPLATE}
            link={`${web ? ModulePrefixes.SITE_SETTINGS: ModulePrefixes.SITE_TEMPLATE}/${item.module}${
              search ?? ""
            }`}
          />
        ))}
      </div>
    </>
  );
}
